import React from "react";
import { getThemeDesign } from "../theme/theme.manager";

interface ActionButtonsProps {
  onLike: () => void;
  onDislike: () => void;
  feedback?: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onLike,
  onDislike,
  feedback,
}) => {
  const themeDesign = getThemeDesign();
  const isLikeActive = feedback === "like";
  const isDislikeActive = feedback === "dislike";
  const isLikeDisabled = isLikeActive;
  const isDislikeDisabled = isDislikeActive;

  return (
    <div className="flex flex-row items-center">
      <div className="flex gap-2.5">
        {/* 解決した */}
        <button
          onClick={onLike}
          disabled={isLikeDisabled}
          className="pathbee-resolved-btn flex items-center min-h-7 px-3 py-1 rounded border transition-all duration-200 disabled:cursor-not-allowed whitespace-nowrap font-medium"
          style={{
            fontSize: "var(--bot-bubble-font-size, 0.95em)",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "var(--resolved-btn-border)",
            backgroundColor: isLikeActive
              ? "var(--resolved-btn-bg-active)"
              : "var(--resolved-btn-bg)",
            color: "var(--resolved-btn-text)",
            opacity: isLikeActive ? 0.7 : 1,
            paddingRight: "10px",
            cursor: isLikeDisabled ? "not-allowed" : "pointer",
          }}
        >
          {/* マルアイコン */}
          <div
            style={{
              width: "1.5em",
              height: "1.5em",
              marginRight: "0.375em",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            aria-hidden
          >
            <div
              style={{
                width: "0.75em",
                height: "0.75em",
                borderRadius: "50%",
                border: "0.12em solid var(--resolved-btn-text)",
                boxSizing: "border-box",
              }}
            />
          </div>
          <span className="font-medium">
            {themeDesign.resolved_button_label || "解決した"}
          </span>
        </button>

        {/* 解決しなかった */}
        <button
          onClick={onDislike}
          disabled={isDislikeDisabled}
          className="pathbee-unresolved-btn flex items-center min-h-7 px-3 py-1 rounded border transition-all duration-200 disabled:cursor-not-allowed whitespace-nowrap font-medium"
          style={{
            fontSize: "var(--bot-bubble-font-size, 0.95em)",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "var(--unresolved-btn-border)",
            backgroundColor: isDislikeActive
              ? "var(--unresolved-btn-bg-active)"
              : "var(--unresolved-btn-bg)",
            color: "var(--unresolved-btn-text)",
            opacity: isDislikeActive ? 0.7 : 1,
            paddingRight: "10px",
            cursor: isDislikeDisabled ? "not-allowed" : "pointer",
          }}
        >
          {/* ✕アイコン */}
          <div
            style={{
              width: "1.5em",
              height: "1.5em",
              marginRight: "0.375em",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            aria-hidden
          >
            <div
              style={{
                position: "relative",
                width: "0.75em",
                height: "0.75em",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  width: "0.75em",
                  height: "0.1em",
                  backgroundColor: "var(--unresolved-btn-text)",
                  transform: "translateY(-50%) rotate(45deg)",
                  transformOrigin: "center",
                  borderRadius: "0.02em",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  width: "0.75em",
                  height: "0.1em",
                  backgroundColor: "var(--unresolved-btn-text)",
                  transform: "translateY(-50%) rotate(-45deg)",
                  transformOrigin: "center",
                  borderRadius: "0.02em",
                }}
              />
            </div>
          </div>
          <span className="font-medium">
            {themeDesign.unresolved_button_label || "解決しなかった"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default ActionButtons;
